export default (el: Element, wrapper: Element): Element => {
  el.replaceWith(wrapper)
  wrapper.appendChild(el)

  return wrapper
}
